import BarraSecundaria from '../Components/BarraSecundaria';
import '../Styles/productos.css';
import {Container,Row,Col} from 'react-bootstrap';
import {Link} from 'react-router-dom'
import {useFirestore} from "../hooks/useFirestore";

  const Productos = () => {

    const [data, error, loading] = useFirestore();

    if(loading) return <div className='loader'></div>
    if (error) return <p>{error}</p>
  return (
    <>
      
      <Container fluid="100%" id="inicio">
        <Row>
          <Col>
            <div className="portadaPrincipal">
              <div className="logoPrincipal2">
                <img alt="logoGrande" className="logoGrande" src="./img/milaLogo.png"/>
              </div>        
            </div>
          </Col>
          <Col>
            <div 
              className='portada_prod_img'
              // style={{backgroundColor: 'red'}}
            >
              <h2>Todos los nuevos productos</h2>
          
            </div>
          </Col>
        </Row>
      </Container>

      <BarraSecundaria />
      <div id="productos_categoria">
        <div className="producto_section">
                {
                data.length > 0 ? (
                    data.map(item => (
                    
                    <Link style={{ textDecoration: 'none', color:'inherit'}} to={`producto/${item.id}`}>
                        <div key={item.id} className="producto" >  
                            <div className='img_prod'>    
                        
                            <img 
                                src={item.imagen}
                                alt="producto"/>
                            </div>   
                            <div className="titulo_prod">
                            {item.nombre}
                        
                            </div>     
                            <div className='precio_prod'>
                            <p> <b>S/.</b>{item.precio}</p>
                            </div>
                        </div>
                    </Link>
                    
                ))  
                ):(
                <p> No hay productos</p>
                )
                }
            </div>
      </div>  
      
    </>
    
  )
}

export default Productos